import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslationService } from './translation.service';
import { LocalStorageService } from './localstorage.service';
import { SportsService } from './sport.service';
import { environment } from '../../environments/environment';
import { GenericService } from './generic.services';

@Injectable({
  providedIn: 'root',
})
export class TeamsFavoritesService {
  private urlAPI = environment.API;
  private urlGetTeamsBySearch = 'getAllTeamsBySearch';
  private teamById = 'getTeamByIdFutbol';
  private teamInfoById = 'getTeamInformationById';
  private teamLineUpById = 'getTeamLineupById';

  constructor(
    private readonly translatorService: TranslationService,
    private readonly lsService: LocalStorageService,
    private http: HttpClient,
    public readonly sportsServices: SportsService,
    public genericServices: GenericService
  ) {}

  favoriteTeam(team: any): any {
    if (this.lsService.setFavoritesTeam(team)) {
      team.favorite = !team.favorite;
      return team;
    }
  }

  /***
   * Obtain all teams to search favorites
   */
  getTeamsBySearch(searchText: any): Observable<any> {
    return this.http.post<any>(
      `${this.urlAPI}${
        this.urlGetTeamsBySearch
      }/${this.translatorService.getCurrentLanguage()}`,
      {
        sport: this.sportsServices.sportSearchText(),
        favoriteTeams: this.lsService.getFavoriteFromLocal('TEAM'),
        searchText,
      }
    );
  }

  /***
   * Obtain info team by id
   */
  getTeamById(id: string, hasSport?: string): Observable<any> {
    return this.http.get<any>(
      `${this.urlAPI}${this.teamById}/${
        hasSport ? hasSport : this.translatorService.getCurrentLanguage()
      }/${id}`
    );
  }

  /***
   * Obtain All info team by id
   */
  getTeamInfoById(id: string, competitionId: string): Observable<any> {
    const sport =
      this.sportsServices.getSelectedSport() === 'Futbol'
        ? 'Futbol'
        : '/' + this.sportsServices.getSelectedSport();
    const competition_id = competitionId ? '/' + competitionId : '';

    return this.http.get<any>(
      `${this.urlAPI}${this.teamInfoById + sport}/${
        this.translatorService.getCurrentLanguage() + competition_id
      }/${id}`
    );
  }

  /***
   * Obtain lineup team by id
   */
  getTeamLineUpById(id: string): Observable<any> {
    const selectedSport =
      this.sportsServices.getSelectedSport() === 'Futbol'
        ? 'Futbol'
        : '/' + this.sportsServices.getSelectedSport();
    const date: any = this.genericServices.getCurrentTimeUnix();

    return this.http.get<any>(
      `${this.urlAPI}${
        this.teamLineUpById
      }${selectedSport}/${this.translatorService.getCurrentLanguage()}/${id}/${date}`
    );
  }
}
